import React, { FC } from 'react'
import { FlexRow } from 'components/Flex'
import { BusinessHourLabel } from 'components/Card'
import { VerticalLine } from 'components/Utility'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getLastOrderTime, getLastPickupTime, getOrderStartTime } from 'reducks/store/selectors'
import { getBusinessTimeOnDay } from 'lib/businessHour'
import { getStoreCalendars } from 'reducks/storeCalendar/selectors'
import { getSpecialHolidays } from 'reducks/calendar/selectors'
import { DaysOfWeek } from 'lib/daysOfWeek'
import { dateToString } from 'lib/helper'
const daysOfWeek = new DaysOfWeek()

const BusinessHourLabelRow: FC = React.memo(() => {
  const lastOrderTime = useSelector((state: State) => getLastOrderTime(state))
  const lastPickupTime = useSelector((state: State) => getLastPickupTime(state))
  const orderStartTime = useSelector((state: State) => getOrderStartTime(state))
  const specialHolidays = useSelector((state: State) => getSpecialHolidays(state))
  const storeCalendars = useSelector((state: State) => getStoreCalendars(state))
  const date = dateToString(new Date())
  const dayOfWeek = daysOfWeek.getDayOfWeek(new Date(), specialHolidays)

  return (
    <FlexRow justifyContent={'around'}>
      <BusinessHourLabel
        label={'オーダー開始'}
        time={getBusinessTimeOnDay(dayOfWeek, orderStartTime, date, storeCalendars, 'order_start_time')}
      />
      <VerticalLine height={52} horizontalMargin={0} />
      <BusinessHourLabel
        label={'ラストオーダー'}
        time={getBusinessTimeOnDay(dayOfWeek, lastOrderTime, date, storeCalendars, 'last_order_time')}
      />
      <VerticalLine height={52} horizontalMargin={0} />
      <BusinessHourLabel
        label={'最終受取'}
        time={getBusinessTimeOnDay(dayOfWeek, lastPickupTime, date, storeCalendars, 'last_pickup_time')}
      />
    </FlexRow>
  )
})

export default BusinessHourLabelRow
